import PropTypes from 'prop-types';

export const AlertProps = PropTypes.shape({
  id: PropTypes.string.isRequired,
  group: PropTypes.string,
  level: PropTypes.oneOf(['info', 'warning', 'error', 'success']).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func,
  timeout: PropTypes.number
});

export const AlertDefaults = {
  id: '',
  group: '',
  level: 'error',
  title: '',
  message: '',
  onClose: () => {},
  timeout: null
};
